import type { Player } from "."

export const getActivePlayers = ({
  players,
}: {
  players: Player.Collection
}): Player.Collection => {
  return players.filter(({ active }) => active)
}
